<template>
  <div
    class="d-flex flex-row flex-wrap"
    :style="{ height: 'fit-content' }"
  >
    <v-alert
      dense
      type="info"
      elevation="2"
      icon="mdi-bullhorn"
      color="#247784"
      colored-border
      border="bottom"
      height="fit-content"
      class="ml-2 mt-10 pb-10"
    >
      <h3 style="margin-bottom: 6px;">Information</h3>
      <p>
        1. Pastikan setiap informasi yang diinput sesuai, benar dan valid untuk menghindari kesalahan dan mempercepat proses penyelesaian.
      </p>
      <p>
        2. Keakuratan data sangat penting untuk menjaga kepercayaan nasabah dan memastikan kelancaran proses. 
        Terima kasih.
      </p>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'InformationAlert',
};
</script>
